import { DtoRequestBiztripsPostReq } from "./abst/DtoRequestBiztripsPostReq";
import { EntityRequest } from "../entity/EntityRequest";

export class DtoRequestBiztripsPostReqImple extends DtoRequestBiztripsPostReq {
  public request = new EntityRequest();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック

    return res;
  }
}
